import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Calendar, MapPin, Linkedin } from 'lucide-react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <motion.div
              className="footer-column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="footer-brand">
                <div className="footer-logo">
                  <img src="/logowhite.svg" alt="Baseline Racquets Consultants of America" className="footer-logo-image" />
                </div>
                <p className="footer-tagline">
                  Reshaping the world of racquet sports through innovation and expertise.
                </p>
              </div>
            </motion.div>

            <motion.div
              className="footer-column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Our Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </motion.div>

            <motion.div
              className="footer-column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-links">
                <li><Link to="/memberships">Memberships</Link></li>
                <li><Link to="/blxm-course">BLXM Course</Link></li>
                <li><Link to="/services#club-consulting">Club Consulting</Link></li>
                <li><Link to="/services#retreats">Retreats</Link></li>
              </ul>
            </motion.div>

            <motion.div
              className="footer-column"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <h4 className="footer-heading">Get in Touch</h4>
              <div className="footer-contact">
                <a href="mailto:info@baselineconsulting.org" className="footer-contact-item">
                  <Mail size={18} />
                  <span>info@baselineconsulting.org</span>
                </a>
                <a href="https://calendar.app.google/zeaz1ocNpttMocbv7" className="footer-contact-item">
                  <Calendar size={18} />
                  <span>Book Consultation Today</span>
                </a>
                <div className="footer-contact-item">
                  <MapPin size={18} />
                  <span>Global Operations</span>
                </div>
              </div>
              <div className="footer-social">
                <a 
                  href="https://www.linkedin.com/company/baseline-consulting-usa" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="LinkedIn" 
                  className="social-link"
                >
                  <Linkedin size={20} />
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Baseline Racquets Consultants of America. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
